import { render } from "./ProjectDonationSearchForm.vue?vue&type=template&id=14664048"
import script from "./ProjectDonationSearchForm.vue?vue&type=script&lang=js"
export * from "./ProjectDonationSearchForm.vue?vue&type=script&lang=js"
script.render = render

export default script